import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from "./auth.service";
import {map, take, tap} from "rxjs/operators";
import {loggedIn} from "@angular/fire/auth-guard";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth.user$.pipe(
      take(1),
      map(user => {
        return user && (!route.data.roles || route.data.roles.includes(user.role));
      }),
      tap(authorized => {
        if(!authorized) {
          console.log("access denied");
          this.router.navigate(['/']);
        }
      })
    );
  }
}
